/**
 * Опрос по экологии клиента-компании (`/ecology/survey?site=<id>`, ecology-survey, макет варианта Б
 * 17.09): мастер по площадке — выбор площадки, четыре раздела вопросов, проверка, результат. После
 * завершения — переход в «Проектные работы», «Отчётность», «Лабораторный контроль» или к обзору
 * раздела.
 */
import { useNavigate, useSearchParams } from 'react-router-dom'
import { ecologyClientApi } from '@/lib/api'
import { useEcoData } from '@/ecology/use-eco-data'
import { useEcoQuestions } from '@/ecology/use-eco-questions'
import { SurveyWizard } from '@/ecology/survey/survey-wizard'
import { useStartEcoOrder } from '@/ecology/order/start-order'
import { PageHead } from '@/design-system/components/layout/page-head'
import { Panel } from '@/design-system/components/layout/panel'
import { Alert } from '@/design-system/components/feedback/alert'

export function EcologySurveyPage() {
  const navigate = useNavigate()
  const [params] = useSearchParams()
  const { overview, catalog, loading, error, setOverview } = useEcoData(ecologyClientApi)
  const { questions, error: questionsError } = useEcoQuestions()
  const order = useStartEcoOrder()

  return (
    <div>
      <PageHead
        title="Опрос по экологии"
        subtitle="Опрос проходится по каждой площадке отдельно. По ответам кабинет подберёт документы и отчётность для площадки"
      />
      {order.error ? (
        <Alert variant="danger" className="mb-4">
          {order.error}
        </Alert>
      ) : null}
      {error || questionsError ? (
        <Alert variant="danger">{error ?? questionsError}</Alert>
      ) : loading || !overview || !questions ? (
        <Panel>
          <p className="px-4 py-10 text-center text-txt-secondary">Загрузка…</p>
        </Panel>
      ) : (
        <SurveyWizard
          api={ecologyClientApi}
          overview={overview}
          questions={questions}
          catalog={catalog}
          initialSiteId={params.get('site')}
          onOverviewChange={setOverview}
          onOrder={order.start}
          exit={{
            back: { label: 'Отмена', onClick: () => navigate('/ecology') },
            after: [
              { label: 'Проектные работы', onClick: () => navigate('/ecology/projects') },
              { label: 'Отчётность', onClick: () => navigate('/ecology/reports') },
              { label: 'Лабораторный контроль', onClick: () => navigate('/ecology/lab') },
              { label: 'К площадкам', onClick: () => navigate('/ecology') },
            ],
          }}
        />
      )}
    </div>
  )
}
